const storageKey = 'stayon.support-session';

/**
 * Nur die Sitzungs-Id übersteht ein Neuladen des Tabs, das Token nie: nach dem Neuladen stellt
 * die Heimatsitzung ein neues aus. sessionStorage gehört dem Tab, kein anderer Tab liest mit.
 */
export const supportSessionStorage = {
  read(): string | null {
    try {
      return sessionStorage.getItem(storageKey);
    } catch {
      return null;
    }
  },
  write(sessionId: string | null): void {
    try {
      if (sessionId) sessionStorage.setItem(storageKey, sessionId);
      else sessionStorage.removeItem(storageKey);
    } catch {
      // Ohne Speicher kehrt der Tab beim Neuladen in die Heimatsitzung zurück; die Sitzung selbst
      // endet serverseitig spätestens mit ihrem Ablauf.
    }
  },
};
